import React, { useState, useRef } from 'react';

import createStyle from 'shared-utils/src/createStyle';

import ArrowSml from 'shared-vectors/icons/FilterArrow';
import Arrow from 'shared-vectors/icons/FilterArrowDsk';
import { Icon } from 'shared-vectors';

import Grid from '../../../Grid';
import GridItem from '../../../GridItem';

import { useCardContext } from '../../index';

import styles, { mainCls } from './style';

const useStyles = createStyle(styles);

const formatRangeValues = (range, hasbold = false) => {
  if (!range.value) {
    return '-';
  }
  // return <>{range.from ? `${range.from} ` : ''}<span className={hasbold ? 'tp-w--l' : null}>{range.value}</span></>;
  const pre = range.from ? `${range.from.replace('da ', '')}` : '';
  return <>{pre ? <>{pre} </> : ''}<span className={hasbold ? 'tp-w--l' : null}>{range.value}</span></>;
}

export default function Units({
  data,
  title,
  goToPDP,
}) {
  const { maplist } = useCardContext();

  const cls = useStyles();

  const unitListContainer = useRef(null);

  const [isUnitListExpanded, setIsUnitListExpanded] = useState(false);

  const { match, units } = data;

  const toggleUnitList = () => {
    const { current: unitListContainerEl } = unitListContainer;
    if (isUnitListExpanded) {
      unitListContainerEl.style.maxHeight = maplist ? '192px' : '132px';
    } else {
      unitListContainerEl.style.maxHeight = `${unitListContainerEl.scrollHeight}px`;
    }
    setIsUnitListExpanded(!isUnitListExpanded);
  };

  return (
    <GridItem
      className="bt--s c-br--bg"
      behavior="fixed"
    >
      <p className={`${cls[`${mainCls}__tit`]} pt--s pr--m pb--s pl--m tp-s--s tp-w--l c-txt--f0`}>{match} Tipologi{match === 1 ? 'a' : 'e'} corrispondent{match === 1 ? 'e' : 'i'} ai tuoi criteri:</p>
      <div ref={unitListContainer} className={`${cls[`${mainCls}__container`]} ${maplist ? cls[`${mainCls}__container__map`] : ''}`}>
        {units.map((unit, index) => {
          const linkCLick = (e) => goToPDP({ e, unitUri: unit.uri });
          const rightCLick = (e) => goToPDP({ e, rightClick: true, unitUri: unit.uri });
          return (
            <div key={unit.id} className={`c-bg--${index === 0 || index % 2 === 0 ? 'bg' : 'w'}`}>
              <Grid
                className={`${cls[`${mainCls}__grid`]} pr--m pl--m is-rel`}
                align="center"
                taghtml="a"
                href={unit.uri}
                title={`${title.main}: ${unit.pType}`}
                onClick={linkCLick}
                onContextMenu={rightCLick}
              >
                <GridItem taghtml="span">
                  <Grid gutters="m" taghtml="span">
                    <GridItem taghtml="span" className={`${!maplist ? cls[`${mainCls}__type`] : cls[`${mainCls}__mapfeat`]} tp-s--s tp-w--s c-txt--f0`}>{unit.pType}</GridItem>
                    <GridItem taghtml="span" className={`${maplist ? cls[`${mainCls}__mapfeat`] : 'tp-a--c'} tp-s--s tp-w--s c-txt--f0`}>{unit.rooms || '-'}</GridItem>
                    <GridItem taghtml="span" className={`${maplist ? cls[`${mainCls}__mapfeat`] : 'tp-a--c'} tp-s--s tp-w--s c-txt--f0`}>{formatRangeValues(unit.size)}</GridItem>
                    <GridItem taghtml="span" className={`${cls[`${mainCls}__onlydsk`]}${maplist ? ` ${cls[`${mainCls}__notonmap`]}` : ''} tp-s--s tp-w--s c-txt--f0 tp-a--c`}>{unit.bathrooms || '-'}</GridItem>
                    <GridItem taghtml="span" className={`${cls[`${mainCls}__onlydsk`]}${maplist ? ` ${cls[`${mainCls}__notonmap`]}` : ''} ${cls[`${mainCls}__notonmap`]} tp-s--s tp-w--s c-txt--f0 tp-a--c`}>{unit.level || '-'}</GridItem>
                    <GridItem taghtml="span" className={`${!maplist ? cls[`${mainCls}__price`] : cls[`${mainCls}__mapfeat`]} tp-s--s tp-w--s c-txt--f0`}>{formatRangeValues(unit.price, true)}</GridItem>
                  </Grid>
                </GridItem>
                <GridItem
                  className={`${cls[`${mainCls}__arrowCont`]} pl--s c-txt--f0 is-rel`}
                  behavior="fixed"
                  taghtml="span"
                >
                  <Icon name={Arrow} className={cls[`${mainCls}__arrow`]} width="18px" height="18px" />
                </GridItem>
              </Grid>
            </div>
          );
        })}        
      </div>
      {match > 3 && (
        <button
          type="button"
          className={`${cls[`${mainCls}__reveal`]} tp-s--s tp-w--s c-txt--f5 c-bg--tr tp-a--c b--0 is-clickable`}
          onClick={toggleUnitList}
        >
          <span className={`${cls[`${mainCls}__reveal--cont`]} is-rel`}>
          {isUnitListExpanded ? 'Vedi meno' : 'Vedi altre'}
          <Icon
            className={`${cls[`${mainCls}__reveal__icon`]}${isUnitListExpanded ? ' inverted' : ''}`}
            name={ArrowSml}
            width="12px"
            height="12px"
            fill
          />
          </span>
        </button>
      )}
    </GridItem>
  );
}